import axios from '@/core/axios'
import { useQuery } from '@tanstack/react-query'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { FeatureFlag } from 'stoux-shared-types/models/feature-flag'

export default function MaintenanceProvider({
    children,
}: {
    children: React.ReactNode
}) {
    return <>{children}</>
    const query = useQuery({
        queryKey: ['maintenance-ff'],

        queryFn: async () => {
            const { data } = await axios.get('/ff/maintenance')
            return (data as { feature_flag: FeatureFlag }).feature_flag
        }
    })
    const maintenance = query.data as FeatureFlag

    const router = useRouter()
    useEffect(() => {
        if (router.pathname === '/maintenance') {
            if (!maintenance.enabled) {
                router.push('/')
            }
            return
        }
        if (!maintenance || !maintenance.enabled || !router) return

        router.push('/maintenance')
    }, [maintenance, router])

    return <>{children}</>
}
